import React from 'react';
import * as C from "./style"

const Header = () => {
  return (
    <C.Container>
        <C.Header>
            <C.Title>
                Athomo Financial Control
            </C.Title>
        </C.Header>
    </C.Container>
    
  )
}

export default Header